module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Y3T Coaching","short_name":"Y3T","start_url":"/","background_color":"#1b1b1b","theme_color":"#d41f1f","display":"minimal-ui","icon":"src/images/icon_600x600.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"e916be8e4900eaf45a7898403b4932a2"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
